// The web demo (docs/09 Phase 6): Act I and the start of Act II, capped at It Wakes plus two
// Reckonings, ending on a wishlist card. A build-time flag (`VITE_DEMO=1`); the sim is unchanged,
// the Web simply doesn't offer anything past the cap.
import { NODES } from '../content/registry';
import { webDepth } from '../content/webLayout';
import type { MetaState } from '../sim/types';

export const DEMO = import.meta.env.VITE_DEMO === '1';
/** Where the end card sends players (set at build time). */
export const STORE_URL: string = import.meta.env.VITE_STORE_URL ?? '';

const DEMO_LAST_GATE = 'G_GROW_1';
const DEMO_RECKONINGS = 2;
const DEPTH = webDepth();
const CAP = DEPTH.get(DEMO_LAST_GATE) ?? 0;

/** In the demo, no gate deeper than It Wakes (stat nodes up to one step past it). */
export function demoAllows(id: string): boolean {
  if (!DEMO) return true;
  const d = DEPTH.get(id) ?? Infinity;
  const gate = NODES.get(id)?.kind !== 'stat';
  return gate ? d <= CAP : d <= CAP + 1;
}

/** The demo is over once It Wakes is bought and two Reckonings are beaten. */
export function demoOver(meta: MetaState): boolean {
  return DEMO && (meta.nodes[DEMO_LAST_GATE] ?? 0) > 0 && meta.lifetime.reckoningsBeaten >= DEMO_RECKONINGS;
}
